export default "__VITE_ASSET__BpzB9tHr__"